import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_DURATIONS } from 'ui-components/services/notification-service';

import { messages } from '../messages';

export const successfullyUpdatedBillingInfoNotification = (brandName) => ({
  title: <FormattedMessage {...messages.updateBillingInfoSuccessTitle} />,
  notificationType: NOTIFICATION_TYPE_SUCCESS,
  content: brandName ? (
    <FormattedMessage {...messages.newUpdateBillingInfoSuccessWithWallet} />
  ) : (
    <FormattedMessage {...messages.updateBillingInfoSuccessWithoutWallet} />
  ),
  duration: NOTIFICATION_DURATIONS.SHORT,
});

export const failedToChangePlanNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.failedToChangePlan} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

export const cardDeclinedNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.cardDeclined} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

export const failedToUpdateAddOnsNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.failedToUpdateAddOns} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

export const paypalBillingErrorNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.paypalBillingError} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

export const getSubscriptionInfoErrorNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.getSubscriptionInfoError} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

export const cancellationRequestErrorNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.cancellationRequestError} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

export const updateAddOnsSuccessNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_SUCCESS,
  content: <FormattedMessage {...messages.updateAddOnsSuccess} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

export const failedToUpdateUserNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.failedToUpdateUser} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

export const getCancellationInfoErrorNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.getCancellationInfoError} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

export const updateBillingEmailErrorNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.updateBillingEmailError} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

export const newUpdateBillingErrorNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.updateBillingError} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

export const noBillingAddressErrorNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.noBillingAddress} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

export const noPhoneErrorNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.noPhoneNumber} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};

export const failedUpdatePBSBillingInfoNotification = {
  title: '',
  notificationType: NOTIFICATION_TYPE_ERROR,
  content: <FormattedMessage {...messages.failedUpdatePBSBillingInfo} />,
  duration: NOTIFICATION_DURATIONS.SHORT,
};
